module.exports = __webpack_public_path__ + "img/infj.6ecacc18.png";